var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.visivel)?_c('div',{staticClass:"fullscreen",on:{"click":_vm.esconderImagem}},[_c('img',{attrs:{"src":_vm.scrImagem,"onerror":"this.onerror=null; this.src='./img/semimagem.png'"}}),_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"cardapio-digital-detalhe-produto-section-btn-voltar is-clickable fas fa-arrow-left"}),_vm._v(" Voltar ")])
}]

export { render, staticRenderFns }